"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("@jsluna/button");

var _form = require("@jsluna/form");

var _grid = require("@jsluna/grid");

var _icons = require("@jsluna/icons");

var _pdfIcon = _interopRequireDefault(require("../assets/pdfIcon.png"));

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MediaInput = function MediaInput(_ref) {
  var orderId = _ref.orderId,
      media = _ref.media,
      remove = _ref.remove,
      handleMediaReplace = _ref.handleMediaReplace,
      handleDescriptionUpdated = _ref.handleDescriptionUpdated;
  var thumbnail;

  switch (media.type) {
    case _constants.FILE_TYPE_IMAGE:
      thumbnail = media.data;
      break;

    case _constants.FILE_TYPE_PDF:
      thumbnail = _pdfIcon.default;
      break;
  }

  return /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/2'
    },
    className: "ln-u-push-top"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/3",
    className: "ln-u-hard-left"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: thumbnail,
    alt: "Placeholder",
    className: "fullscale-image"
  })), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "2/3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-push-bottom-sm"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "media-file-name"
  }, media.file.name)), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "imageTitle",
    placeholder: "Enter a brief image description",
    className: "ln-u-push-bottom-sm",
    onChange: function onChange(e) {
      return handleDescriptionUpdated(e.target.value);
    },
    defaultValue: media.description
  }), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "3/4",
    className: "ln-u-hard-left"
  }, /*#__PURE__*/_react.default.createElement(_button.LinkButton, {
    color: "dark",
    onClick: function onClick(e) {
      return handleMediaReplace(e, orderId);
    }
  }, "Replace Media")), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/4"
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    className: "ln-u-hard-right",
    label: "deleteMediaImage",
    hideLabel: true,
    onClick: function onClick() {
      return remove();
    },
    style: {
      height: '42px'
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Delete, null)))));
};

MediaInput.propTypes = {
  orderId: _propTypes.default.number,
  media: _propTypes.default.object.isRequired,
  remove: _propTypes.default.func.isRequired,
  handleMediaReplace: _propTypes.default.func.isRequired,
  handleDescriptionUpdated: _propTypes.default.func.isRequired
};
MediaInput.defaultProps = {
  orderId: 0
};
var _default = MediaInput;
exports.default = _default;